// permissionMatrix.js
export function getTicketPermissions(role, status) {
	// Example matrix: each role has sub-objects by status
	const matrix = {
		admin: {
            new: {
                canEditTitle: true,
                canEditProductionType: true,
                canAssignProducer: false,
                canEditScenes: true,
                canEditAssets: true,
                canEditDueDate: true,
                canAddVideo: false,
                canEditScript: true,
                // ...
            },
			open: {
				canEditTitle: false,
				canEditProductionType: true,
				canAssignProducer: true,
                canEditScenes: false,
                canEditAssets: false,
                canEditDueDate: true,
                canAddVideo: false,
                canEditScript: false,
				// ...
			},
            assigned: {
                canEditTitle: false,
                canEditProductionType: true,
                canAssignProducer: false,
                canEditScenes: false,
                canEditAssets: false,
                canEditDueDate: true,
                canAddVideo: false,
                canEditScript: false,
                // ...
            },
			inprogress: {
				canEditTitle: false,
				canEditProductionType: false,
				canAssignProducer: false,
                canEditScenes: false,
                canEditAssets: false,
                canEditDueDate: true,
                canAddVideo: false,
                canEditScript: false,
				// ...
			},
            adminreview: {
                canEditTitle: false,
                canEditProductionType: true,
                canAssignProducer: false,
                canEditScenes: true,
                canEditAssets: false,
                canEditDueDate: true,
                canAddVideo: false,
                canEditScript: false,
                // ...
            },
            inreview: {
                canEditTitle: false,
                canEditProductionType: false,
                canAssignProducer: false,
                canEditScenes: false,
                canEditAssets: false,
                canEditDueDate: false,
                canAddVideo: false,
                canEditScript: false,
                // ...
            },
			complete: {
				canEditTitle: false,
				canEditProductionType: false,
				canAssignProducer: false,
                canEditScenes: false,
                canEditAssets: false,
                canEditDueDate: false,
                canAddVideo: false,
                canEditScript: false,
				// ...
			},
		},
		producer: {
            new: {
                canEditTitle: true,
                canEditProductionType: true,
                canAssignProducer: false,
                canEditScenes: true,
                canEditAssets: true,
                canEditDueDate: true,
                canAddVideo: false,
                canEditScript: true,
                // ...
            },
			open: {
				canEditTitle: false,
				canEditProductionType: false,
				canAssignProducer: false,
                canEditScenes: false,
                canEditAssets: false,
                canEditDueDate: false,
                canAddVideo: false,
                canEditScript: false,
				// ...
			},
            assigned: {
                canEditTitle: false,
                canEditProductionType: false,
                canAssignProducer: false,
                canEditScenes: false,
                canEditAssets: false,
                canEditDueDate: false,
                canAddVideo: false,
                canEditScript: false,
                // ...
            },
			inprogress: {
				canEditTitle: false,
				canEditProductionType: false,
				canAssignProducer: false,
                canEditScenes: false,
                canEditAssets: false,
                canEditDueDate: true,
                canAddVideo: true,
                canEditScript: true,
				// ...
			},
            adminreview: {
                canEditTitle: false,
                canEditProductionType: false,
                canAssignProducer: false,
                canEditScenes: false,
                canEditAssets: false,
                canEditDueDate: false,
                canAddVideo: false,
                canEditScript: false,
                // ...
            },
            inreview: {
                canEditTitle: false,
                canEditProductionType: false,
                canAssignProducer: false,
                canEditScenes: false,
                canEditAssets: false,
                canEditDueDate: false,
                canAddVideo: false,
                canEditScript: false,
                // ...
            },
			complete: {
				canEditTitle: false,
				canEditProductionType: false,
				canAssignProducer: false,
                canEditScenes: false,
                canEditAssets: false,
                canEditDueDate: false,
                canAddVideo: false,
                canEditScript: false,
				// ...
			},
		},
		user: {
            new: {
                canEditTitle: true,
                canEditProductionType: true,
                canAssignProducer: false,
                canEditScenes: true,
                canEditAssets: true,
                canEditDueDate: true,
                canAddVideo: false,
                canEditScript: true,
                // ...
            },
			open: {
				canEditTitle: false,
				canEditProductionType: false,
				canAssignProducer: false,
                canEditScenes: true,
                canEditAssets: true,
                canEditDueDate: false,
                canAddVideo: false,
                canEditScript: false,
				// ...
			},
            assigned: {
                canEditTitle: false,
                canEditProductionType: false,
                canAssignProducer: false,
                canEditScenes: false,
                canEditAssets: true,
                canEditDueDate: false,
                canAddVideo: false,
                canEditScript: true,
                // ...
            },
			inprogress: {
				canEditTitle: false,
				canEditProductionType: false,
				canAssignProducer: false,
                canEditScenes: true,
                canEditAssets: true,
                canEditDueDate: false,
                canAddVideo: false,
                canEditScript: false,
				// ...
			},
            adminreview: {
                canEditTitle: false,
                canEditProductionType: false,
                canAssignProducer: false,
                canEditScenes: false,
                canEditAssets: true,
                canEditDueDate: false,
                canAddVideo: false,
                canEditScript: false,
                // ...
            },
            inreview: {
                canEditTitle: false,
                canEditProductionType: false,
                canAssignProducer: false,
                canEditScenes: true,
                canEditAssets: true,
                canEditDueDate: false,
                canAddVideo: false,
                canEditScript: true,
                // ...
            },
			complete: {
				canEditTitle: false,
				canEditProductionType: false,
				canAssignProducer: false,
                canEditScenes: false,
                canEditAssets: false,
                canEditDueDate: false,
                canAddVideo: false,
                canEditScript: false,
				// ...
			},
		},
	};

	// Normalize status keys, e.g. "in progress" => "inprogress"
	const cleanedStatus = status.toLowerCase().replace(/\s+/g, "");

	// Fallback if missing or unknown
	return (
		matrix[role]?.[cleanedStatus] || {
			canEditTitle: false,
			canEditProductionType: false,
			canAssignProducer: false,
            canEditScenes: false,
            canEditAssets: false,
            canEditDueDate: false,
            canAddVideo: false,
            canEditScript: false,
            // ...
		}
	);
}
